import type { FaireProductEntity } from "../../entity_types/product";

export const p_azcu6ym8u5: FaireProductEntity = {
  token: "p_azcu6ym8u5",
  type: "product",
  name: "Fall - Pumpkin Spice Chai Truffle Bar",
  brandToken: "b_adcrph7h",
  brandName: "Seattle Chocolate Presents Maeve",
  imageUrl:
    "https://cdn.faire.com/fastly/7e690674ffdb0233ae8b313eb791b6adba80e7b84cee8137a0e3ed575d5fbc30.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b957dca6568a6ffff52d49c1146c745a0e04439bdb38795f5f9b540374f2ab40.jpeg",
    "https://cdn.faire.com/fastly/638c9bb0287ffee40e793b836e41ec3988a26dae9a7a5bd8c233358783302d52.jpeg",
    "https://cdn.faire.com/fastly/1c575d6431cb6c0883f8c865f6b30615ae889248c1bf859902bcb183c1a8df68.jpeg",
  ],
  priceDollars: 3.66,
  description:
    "This isn’t just pumpkin spice chocolate, it’s your unofficial invitation to overcommit to fall. We’re talking a chai milk chocolate truffle bar infused with classic pumpkin pie spices, ideal for sipping coffee at town meetings, dodging hayride proposals, or emotionally preparing for your third apple-picking date of the week. Back by popular demand (and town council decree), this fall chocolate bar is peak seasonal serotonin. (2.5oz)\n\nAbout the fall collection:\nWe're pulling over at the roadside pumpkin patch with spiced chais, we're dunking our apple cider donuts in chocolate at the orchard, and we're definitely sitting around the bonfire with a mug of maple bourbon.\n\n•\tWoman-owned and led\n•\t10% net profits donated to cocoa farmers \n•\tEthically sourced, non-GMO chocolate\n•\tCarbon neutral",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:42.863Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
